import { SyncAltRounded } from "@mui/icons-material"

export const TransactionIcon = SyncAltRounded
